import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  AiInsightsRootModalScreenParamList,
  RegisterRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ScreenContext } from "./common";
import { AiInsightsScreen } from "./AiInsightsScreen";
import { AiInsightsActionsRootScreen } from "./AiInsightsActionsRootScreen";

const Stack = createStackHeaderNavigator<AiInsightsRootModalScreenParamList>();

export interface AiInsightsRootModalScreenProps
  extends StackScreenProps<
    RegisterRootParamList,
    "AiInsightsRootModalScreen"
  > {}

export const AiInsightsRootModalScreen = ({
  route,
}: AiInsightsRootModalScreenProps) => {
  const { startDate, endDate } = route.params;

  return (
    <ScreenContext.Provider
      value={{
        startDate: new Date(startDate),
        endDate: endDate ? new Date(endDate) : undefined,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          headerShown: true,
          title: ``,
          headerLeft: () => <ModalCloseButton type="Close" />,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Screen name="AiInsightsScreen" component={AiInsightsScreen} />
        <Stack.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Stack.Screen
            name="AiInsightsActionsRootScreen"
            component={AiInsightsActionsRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ScreenContext.Provider>
  );
};
